export default function() {
  return {
    mode: "",
    staticEntityId: "",
    layers: {},
    layersById: [], // Array of layerIds
    activeLayer: "", // layerId
    meta: {
      name: "",
      description: "",
    },
    activeCity: {},
    activeTime: {},
    isInitialized: false,
    isRequestInProgress: false,
    timeValues: {},
    consoles: {},
    consolesById: [],
    staticEntities: [],
    staticEntityFilters: {},
    staticEntityFiltersById: [],
    appliedFilters: {},
    detailsWidgets: {},
    distributionWidgets: {},
  };
}
